import "@ungap/global-this";
import { DefaultFactory, PlainFactory } from "./PlainFactory";
var setup;
var globalFactory;
var globalSymbol;
if (typeof Symbol !== "undefined") {
    var rdfFactory_1 = Symbol["for"]('rdfFactory');
    setup = function setup(factory, override) {
        if (factory === void 0) { factory = DefaultFactory; }
        if (override === void 0) { override = true; }
        if (typeof globalThis[rdfFactory_1] === "undefined" || override) {
            globalThis[rdfFactory_1] = factory;
            globalFactory = factory;
        }
        else if (typeof globalFactory === "undefined" || override) {
            globalFactory = factory;
        }
    };
    globalFactory = globalThis[rdfFactory_1];
    globalSymbol = rdfFactory_1;
}
else {
    var rdfFactory_2 = 'rdfFactory';
    setup = function setup(factory, override) {
        if (factory === void 0) { factory = DefaultFactory; }
        if (override === void 0) { override = true; }
        if (typeof globalThis[rdfFactory_2] === "undefined" || override) {
            globalThis[rdfFactory_2] = factory;
            globalFactory = factory;
        }
        else if (typeof globalFactory === "undefined" || override) {
            globalFactory = factory;
        }
    };
    globalSymbol = rdfFactory_2;
    globalFactory = globalThis[rdfFactory_2];
}
export var createNS = function (ns) {
    return function (term) {
        return globalFactory.namedNode("" + ns + term);
    };
};
var proxy;
if (typeof Proxy !== "undefined") {
    proxy = new Proxy(globalFactory || {}, {
        ownKeys: function () {
            return globalFactory && Object.keys(globalFactory) || [];
        },
        getOwnPropertyDescriptor: function (_, k) {
            return Object.getOwnPropertyDescriptor(globalFactory, k);
        },
        set: function (_, property, value) {
            globalFactory[property] = value;
            return true;
        },
        get: function (_, property) {
            return globalFactory[property];
        }
    });
}
else {
    proxy = [
        'namedNode',
        'blankNode',
        'literal',
        'defaultGraph',
        'quad',
        'quadruple',
        'fromTerm',
        'fromQuad',
        'fromQdr',
        'qdrFromQuad',
        'qdrFromQdr',
        'equals',
        'id',
        'toNQ',
        'fromId',
        'termToNQ',
        'quadrupleToNQ',
        'quadToNQ',
    ].reduce(function (acc, key) {
        acc[key] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return globalFactory[key].apply(globalFactory, args);
        };
        return acc;
    }, {});
}
export { setup, globalFactory, globalSymbol, PlainFactory, };
export * from './types';
export * from './utilities';
export default proxy;
